import '../WhoYouKnow.css';

export default function Header(){


    return (
        <div className="WhoYouKnow">WhoYouKnow</div>
    )
}